// extracted by mini-css-extract-plugin
export default {"event-text":"user-events-calendar_component_event-text__vryE-"};